import { useEffect, useMemo, useState } from 'react';
import { fetchExportStatus } from '../services/operatorexport.api';

export function useOperatorExportSummaries(currentDate) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch operator status once on mount
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        setLoading(true);
        const list = await fetchExportStatus(ac.signal);

        // Add mapping at this point, on the assumption that data is
        // coming back with date columns of the form: yyyy-mm-dd
        const d = currentDate;
        const today = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const oneDayAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const twoDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const threeDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const fourDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const fiveDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const sixDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const sevenDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const eightDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        d.setDate(d.getDate() - 1);
        const nineDaysAgo = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');

        const mapped = Array.isArray(list)
        ? list.map((op) => ({
            operatorCode: op.OperatorCode,
            nineDaysAgo: op[nineDaysAgo],
            eightDaysAgo: op[eightDaysAgo],
            sevenDaysAgo: op[sevenDaysAgo],
            sixDaysAgo: op[sixDaysAgo],
            fiveDaysAgo: op[fiveDaysAgo],
            fourDaysAgo: op[fourDaysAgo],
            threeDaysAgo: op[threeDaysAgo],
            twoDaysAgo: op[twoDaysAgo],
            oneDayAgo: op[oneDayAgo],
            today: op[today],
          }))
        : [];


        setRows(mapped);
      } catch (e) {
        console.error('useOperatorExportSummaries:init', e);
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
    return () => ac.abort();
  }, []);

  return { rows, loading, refreshing: false };
}
